import type { FC, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const copy = {
  heading: `Become a Twilio Segment Partner`,
  description: `Twilio Segment gets your software and services in front of our growing user base of 25,000+ companies—along with sales support, technical training, and personalized co-marketing opportunities.`,
}

const BecomeSegmentSelect: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <SectionBaseStyled variant="centered">
        <Section.Copy>
          <StyledCopyText centered={true}>
            <CopyText.Heading variant="h1" tag="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="h2" variant="pLarge">
              {copy.description}
            </CopyText.Description>
          </StyledCopyText>
        </Section.Copy>
      </SectionBaseStyled>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.brand.segmentGreen[100]};
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding-top: 80px;
  }
`

const SectionBaseStyled = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-bottom: 0;
  }
`

const StyledCopyText = styled(CopyTextBase)`
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    text-align: left;
  }
`

export default BecomeSegmentSelect
